/**
  * Dropdown component Events and Methods
  *
  * @param {element} element - Dropdown element
  */
class Dropdown {
  constructor(element) {
    this.dropdown = element;
    this.toggleCTA = element.querySelector('.dropdown-toggle');
    this.supportedEvents = ["click", "touchend", "mouseenter", "mouseleave", "focusout"];

    this.init();
  }

  init() {
    this.supportedEvents.forEach((type) => {
      if (type === 'click' || type === 'touchend') {
        this.toggleCTA.addEventListener(type, (evt) => {
          evt.preventDefault();
          this.toggleDropdown();
        });
      } else if(type === 'mouseenter') {
        this.toggleCTA.addEventListener(type, (evt) => {
            this.dropdownShow(this.dropdown);
        });
        this.toggleCTA.addEventListener(type, (_evt) => {
          this.childOnFocusChange(this.dropdown);
        });
      } else if(type === 'mouseleave') {
        this.dropdown.addEventListener(type, (evt) => {
          this.dropdownHide(this.dropdown);
        });
      } else if(type == 'focusout'){
        this.dropdown.addEventListener(type, (evt) => {
          if (!this.dropdown.contains(evt.relatedTarget) && this.dropdown.classList.contains('open')) {
            this.dropdownHide(this.dropdown);
          }
        });
      }
    });

    this.bindEvents();
  }

  bindEvents(){
    const closeBtn = this.dropdown.querySelector('.close-submenu');
    if (closeBtn) {
      // console.log(this.dropdown), 'this.dropdown';
      
      closeBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        this.dropdownToggle(this.dropdown);
      });
    }
    document.querySelectorAll(".customBackArrow").forEach(each=>{
      each.addEventListener('click', (e) => {
          e.preventDefault()
          e.target.closest(".nav-item")?.classList.remove('open')
      } )
    });
    document.querySelectorAll(".customCrossNavBarMob").forEach(each=>{
      each.addEventListener("click", function(e){
          document.querySelector(".customCrossIcon").click()
      })
  })
  }

  toggleDropdown() {
    this.dropdownToggle(this.dropdown);
  }

  dropdownToggle(dropdownParent) {
    setTimeout(() => {
      dropdownParent.classList.contains('open')
        ? this.dropdownHide(dropdownParent)
        : this.dropdownShow(dropdownParent);
    }, 50);
  }

  dropdownShow(dropdownParent) {
    if (!dropdownParent) {
      return;
    }
    this.toggleCTA.setAttribute('aria-expanded', true);
    dropdownParent.classList.add('open');
  }

  dropdownHide(dropdownParent) {
    if (!dropdownParent) return;

    this.toggleCTA.setAttribute('aria-expanded', false);
    dropdownParent.classList.remove('open');

    const childDropdowns = dropdownParent.querySelectorAll('.dropdown.open');
    if (childDropdowns.length > 0) {
      childDropdowns.forEach((child) => {
        child.classList.remove('open');
        child.querySelector('.dropdown-toggle').setAttribute('aria-expanded', false);
      });
    }
  }

  childOnFocusChange(dropdownParent) {
    const openDropdowns = Array.from(dropdownParent.parentElement.querySelectorAll('.dropdown.open'));
    const currentIndex = openDropdowns.indexOf(dropdownParent);
    openDropdowns.forEach((ele) => {
      const eleIndex = openDropdowns.indexOf(ele);
      if (eleIndex !== currentIndex) {
        this.dropdownHide(ele);
      }
    });
  }
}
const allDropdowns = document.querySelectorAll('[is="drop-down"]');
allDropdowns.forEach((ele) => {
  new Dropdown(ele);
});

/**
* background Overlay
*/
class SiteOverlay extends HTMLElement{
  constructor() {
    super();
    this.overlayElement = document.querySelector('#site-overlay');
    this.bindEvents();
  }

  /**
   * bind Click and Touchend event to this custom component
   */
  bindEvents(){
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('touchend', this.onClick.bind(this));
  }

  /**
   * Click event of Site overlay
   */
  onClick(){
    const closeSearch = document.querySelector('search-modal')?.classList.contains("open__modal");
    if(closeSearch) document.querySelector('.search-modal__close-button')?.dispatchEvent(new Event('click'));
  
    this.hideOverlay();
  }

  /**
   * Show Overlay
   */
   showOverlay(){
    document.querySelector('#site-overlay').classList.add('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', false);
    document.body.classList.add('scroll-fixed');
  }

  /**
   * Hide overlay
   */
  hideOverlay(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
    const extraDrawer = document.querySelectorAll('custom-drawer-bike-info.open');
    if(extraDrawer){
      extraDrawer.forEach(drawer => {
        drawer.closeDrawer();
      });
    }
    const loginDrawer = document.querySelector('.customLoginDrawer');
    if(loginDrawer){
      loginDrawer.classList.remove('open');
    }
    const predictiveSearch = document.querySelectorAll('predictive-search')
    if(predictiveSearch){
      predictiveSearch.forEach((eachPredictive)=>{
        eachPredictive.hideResults();
      })
    }
    document.querySelector('#site-overlay').classList.remove('overlay--body');
    document.querySelector('#site-overlay').setAttribute('aria-hidden', true);
    document.body.classList.remove('scroll-fixed');
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick.bind(this));
    this.removeEventListener('touchend', this.onClick.bind(this));
  }
}
customElements.define("site-overlay", SiteOverlay, {
  once: true
});

/**
* Custom Video
*/
class CustomVideo extends HTMLElement {
  constructor() {
    super();

    this.type = this.getAttribute('data-video-type');
    this.videoURL = this.getAttribute('data-video-id');
    this.placementType = this.getAttribute('data-placement');
    this.videoStatus = 'empty';

    this.container = this.closest('.custom-video-container');
    this.videoModal = document.getElementById('PopupModal-video');
    this.contentSection = this.querySelector('.content-section');
    this.videoSection = this.querySelector('.video-section');
    if(this.placementType == 'popup') this.videoSection = this.videoModal.querySelector('.video-container');
    this.triggerVideo = this.container?.querySelector('[data-trigger-video]');

  }

  connectedCallback() {
    this.bindEvents();
  }

  disconnectedCallback() {
    if (this.triggerVideo) {
      this.triggerVideo.removeEventListener('click', this.toggleView.bind(this));
    }
  }

  /**
   * Binding events on the video button
   */
  bindEvents(){
    if(this.querySelector('[data-postervideo]')) this.managePosterVideos();
    if(this.triggerVideo) this.triggerVideo.addEventListener('click', this.toggleView.bind(this));
    if(this.dataset.autoplay == 'true' && !this.closest('swiper-slide')) this.autoplayOnInit();
    // if(this.placementType == 'grid') this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Focus Out Event to close drawer
   *
   * @param {event} Event instance
   */
  focusOut(_event){
    if(this.container.classList.contains('playing--video')) this.toggleView();
  }

  /**
   * Toggle of video modal
   */
  toggleView(event){
    if(event) event.preventDefault();
    console.log('this.container', this.container);
    
    const isOpen = this.container.classList.contains('playing--video');
    if (isOpen) {
      this.hideContent();
    } else {
      this.showContent();
    }
  }

  /**
   * Show panel content
   */
  showContent() {
    if (this.videoStatus === 'empty' || this.placementType === 'popup') {
      const videoElement = this._buildVideo();
      videoElement.id = 'custom-video' + Math.floor((Math.random() * 100) + 1);
      this.videoSection?.appendChild(videoElement);
      this.videoStatus = 'loaded';

      setTimeout(() => {
        (this.placementType === 'popup') ? this.openModal(this.videoModal, this.triggerVideo) : this.container.classList.add('playing--video');
        this.videoSection?.setAttribute('aria-hidden', 'false');
        this._playVideo(videoElement);
        if (this.dataset.controls == 'true') this.pauseOnVisibilityChange(videoElement);
      }, 500);
    } else {
      const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
      this.container.classList.add('playing--video');
      this._playVideo(videoElement);
    }
  }

  /**
   * Hide panel content
   */
  hideContent() {
    this.container.classList.remove('playing--video');
    this.videoSection?.setAttribute('aria-hidden', 'true');
    const videoElement = this.querySelector('.video-section video') || this.querySelector('.video-section iframe');
    if (videoElement) {
      this._pauseVideo(videoElement);
    }
  }

  _playVideo(video){
    if(this.type == 'local'){
      video.play();
    }else if(this.type == 'youtube'){
      video.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
      this.classList.remove('youtube-video-play');
    }
  }

  _pauseVideo(video) {
    if (this.type === 'local') {
      video.pause();
    } else if (this.type === 'youtube') {
      video.contentWindow?.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    }
  }

  /**
   * 
   * Create the video html element
   */
  _buildVideo(){
    let video;
    console.log(this.type,"this.type")
    if(this.type == 'local'){
      video = document.createElement('video');
      video.src = this.videoURL;
      if(this.dataset.controls == 'true') video.controls = this.dataset.controls;
      if(this.dataset.muted == 'true') video.muted = this.dataset.muted;
      if(this.dataset.autoplay == 'true') video.autoplay = this.dataset.autoplay;
      if(this.dataset.loop == 'true') video.loop = this.dataset.loop;
      video.playsInline = true;
    }else if(this.type == 'youtube'){
      const videoID = this.videoURL.replace('https://www.youtube.com/watch?v=', '');
      video = document.createElement( "iframe" );
      video.setAttribute( "allowfullscreen", "" );
      video.setAttribute( "frameborder", "0" );
      video.setAttribute( "allow", "autoplay");
      video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=${this.dataset.autoplay == 'true' ? 1 : 0}&muted=${this.dataset.muted == 'true' ? 1 : 0}&controls=${this.dataset.controls == 'true' ? 1 : 0}&loop=${this.dataset.loop == 'true' ? 1 : 0}&enablejsapi=1&origin=${window.origin}` );
      this.classList.add("youtube-video-parent");
      // &playlist=${videoID}
    }
    
    return video;
  }

  /**
   * Pause video on scroll when out of viewport
   *
  */
  pauseOnVisibilityChange(videoEle){
    this.scrollObserver = new IntersectionObserver((entries) => { 
      if(videoEle == undefined || videoEle.contentWindow == null){
        this.scrollObserver.disconnect();
        return;
      }

      if(!entries[0].isIntersecting){
        this._pauseVideo(videoEle)
      }
    });
    this.scrollObserver.observe(videoEle);
  }

  /**
   * Poster Video Autoplay
   *
  */
  managePosterVideos(){
    const posterVideo = this.querySelector('[data-postervideo]');
    if(!posterVideo) return;

    const videoIntersection = (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting && entry.target) {
          const sourceTag = document.createElement('source');
          sourceTag.src = entry.target.dataset.src;
          sourceTag.type = "video/mp4";
          entry.target.appendChild(sourceTag)
          entry.target.play();
          observerPosterVideo.disconnect();
        }
      }
    };
    const observerPosterVideo = new IntersectionObserver(videoIntersection);
    observerPosterVideo.observe(posterVideo);
  }

  autoplayOnInit(element = this){
    const elementIntersection = (entries) => {
      if(entries[0].isIntersecting && entries[0].intersectionRatio > 0){
        element.toggleView();
        observeElement.disconnect();
      }
    };
    let observeElement = new IntersectionObserver(elementIntersection);
    observeElement.observe(element);
  }
}
customElements.define("custom-video", CustomVideo);

/**
  * Open Modal javscript trigger
  *
  * */
 function openModal(modal, opener){
  if(modal && opener != undefined) modal.show(opener);
}

/**
* Modal Dialogue
*
*/
class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.modal');
    this.modalOpeners = [...document.querySelectorAll(`[data-modal-opener="${this.id}"]`)];
    this.closeBtn = this.querySelector('[id^="ModalClose-"]');
  }

  connectedCallback() {
    this.modalOpeners.forEach((opener)=>{
      opener.addEventListener('click', (evt)=>{
        evt.preventDefault();
        this.show(opener);
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.hide.bind(this));
    }

    this.addEventListener('click', (evt) => {
      if (evt.target === this) this.hide();
    });

    this.addEventListener('keyup', (evt) => {
      if (evt.code && evt.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  // Clean up event listeners
  disconnectedCallback() {
    this.modalOpeners.forEach((opener) => {
      opener.removeEventListener('click', this.show.bind(this));
    });

    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }

    this.removeEventListener('click', this.hide);
    this.removeEventListener('keyup', this.hide);
  }

  /**
   * Open the Modal
   * @param {element} opener 
   */
  show(opener) {
    this.openedBy = opener;
    this.modal.classList.add('open');
    this.setAttribute('aria-hidden', false);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this);
    Utility.forceFocus(this.closeBtn);
  }

  /**
   * Close Modal Dialogue
   */
  hide() {
    this.modal.classList.remove('open');
    this.setAttribute('aria-hidden', true);

    SiteOverlay.prototype.hideOverlay();
    Utility.removeTrapFocus(this.openedBy);
    if(this.id == 'PopupModal-video') this.querySelector('.video-container').innerHTML = '';
  }
}
customElements.define('modal-dialog', ModalDialog);

/**
   * Manage Custom Notification Trigger
   *
   */
class ToastNotification extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector('.snotifyToast');
    this.closeBtn = this.querySelector('.snotifyToast__close');
    this.animateNotifcation = null;

    // Set ARIA role for accessibility
    this.container.setAttribute('role', 'alert');
  }

  connectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();
      });
    }
  }

  disconnectedCallback() {
    if (this.closeBtn) {
      this.closeBtn.removeEventListener('click', this.hide.bind(this));
    }
  }

  /**
   * Notification Type
   * @param {string} title 
   * @param {string} body 
   * @param {object} options 
   */
  updateNotification(title, body, options){
    this.querySelector('.snotifyToast__title').textContent = title;
    this.querySelector('.snotifyToast__body').textContent = body;

    this.container.classList.add('open', `snotify-${options.type}`);
    this._manageToggle(options.timeout);
  }

  /**
   * Duration of notification to hide again
   * @param timeout 
   */
  _manageToggle(timeout) {
    this.progressBar = this.querySelector('[data-toast-pr]');
    const totalFrames = Math.ceil(timeout / 16.67) / 2;
    let frame =0; 
    let width = 0;

    this.animateNotifcation = () => {
      width = (frame / totalFrames) * 100;
      this.progressBar.setAttribute('style', `width: ${width}%`);
      if (frame < totalFrames) {
        frame++;
        requestAnimationFrame(this.animateNotifcation);
      } else {
        this.closeBtn.dispatchEvent(new Event('click'));
      }
    };
    requestAnimationFrame(this.animateNotifcation);
  }

  hide() {
    if (this.animateNotification) {
      cancelAnimationFrame(this.animateNotification);
    }
    this.container.className = 'snotifyToast';
    [this.querySelector('.snotifyToast__title'),this.querySelector('.snotifyToast__body')].forEach(ele => ele.textContent = '');
    this.querySelector("[data-toast-pr]").removeAttribute("style");
  }
}
customElements.define("toast-notification", ToastNotification);
window.notificationEle = document.querySelector('toast-notification');
// notificationEle.updateNotification('Title', 'Body', {
//   type: 'success',
//   timeout: 5000
// });

class CustomDrawer extends HTMLElement {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
      this.closeButton = this.querySelector('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele')
  }

  connectedCallback() {
    this.bindEvents()
  }

  disconnectedCallback() {
    this.toggleDrawer.forEach(btn => btn.removeEventListener('click', this.openDrawer()));

    this.closeButton.removeEventListener('click', this.closeDrawer.bind(this));
    this.removeEventListener('keyup', this.onKeyUp.bind(this));
    this.removeEventListener('focusout', this.focusOut.bind(this));
  }

  bindEvents(){
    this.toggleDrawer.forEach(btn => {
      btn.setAttribute('aria-expanded', false);
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if(!this.isOpen && btn.dataset.for == 'collection-sorting'){
          this.classList.add('collection-sorting');
        }
        (this.isOpen) ? this.closeDrawer(evt) : this.openDrawer(evt.currentTarget);
      });
    });

    this.closeButton?.addEventListener('click', this.closeDrawer.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.focusOut.bind(this));
  }

  /**
   * Escape Key Press to close drawer when focus is within the container
   */
  onKeyUp(evt) {
    if(evt.code && evt.code.toUpperCase() !== 'ESCAPE') return;
    this.closeDrawer();
  }

  /**
   * Focus Out Event to close drawer
   */
  focusOut(evt){
    if (!this.contains(evt.relatedTarget) && this.open) {
      this.closeDrawer();
    }
  }

  openDrawer(opener) {
    this.resetOtherDrawers();
      console.log('drawer openedddddd', opener);
      
    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.openedBy?.setAttribute('aria-expanded', true);

    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
    if(window.innerWidth < 1200 && opener.classList.contains('customMobileDrawer')){
      
      document.querySelectorAll('.shopify-section-group-header-group').forEach(each=>{each.style.zIndex = 'unset'})
    }
    // Extend - Dispatch event
      window.setTimeout(function() {
        console.log('Extend, refreshAjaxSideCart');
      window.dispatchEvent(new Event('refreshAjaxSideCart'))
    }, 500)
    // Extend - End code
  }

  closeDrawer() {
      this.isOpen = false;
      this.classList.remove('open');
      this.setAttribute('aria-hidden', 'true');
      this.openedBy?.setAttribute('aria-expanded', false);
      setTimeout(() => {
        this.classList.remove('collection-sorting');
      }, 500);

      SiteOverlay.prototype.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);
      this.openedBy = null;
      if(window.innerWidth < 1200 ){
        
        document.querySelectorAll('.shopify-section-group-header-group').forEach(each=>{each.style.zIndex = '1150'})
      }
  }

  resetOtherDrawers(){
    const openDrawers = document.querySelectorAll('custom-drawer.open');
    openDrawers.forEach(drawer => {
      drawer.closeDrawer();
    });
  }
}
customElements.define('custom-drawer', CustomDrawer);

class CustomDrawerBikeInfor extends CustomDrawer {
  constructor() {
      super();
      this.isOpen = false;

      this.openedBy = null;
      this.toggleDrawer = document.querySelectorAll(`[data-toggleDrawer="${this.id}"]`);
      this.closeButton = this.querySelector('[data-closedrawer]');
      this.forceFocus = this.querySelector('.drawer-header') || this.querySelector('.first-focusable-ele');
      this.section = document.querySelector('.deep-dive-section');
      this.checkViewport();
      window.addEventListener('resize', this.checkViewport.bind(this));
  }
  openDrawer(opener) {
    this.resetOtherDrawers();
    this.isOpen = true;
    this.openedBy = opener || null;
    this.classList.add('open');
    this.setAttribute('aria-hidden', 'false');
    this.openedBy?.setAttribute('aria-expanded', true);
    document.body.classList.add('bike-info-drawer-opened');
    this.section.classList.add('info-drawer-opened');
    if(this.section.mobileView == false){
      setTimeout(()=>{
        this.section.scrollIntoView();
      },200);  
    }
    console.log(this.showOverlay,"showOverlay")
    if(!this.showOverlay) return;
    
    SiteOverlay.prototype.showOverlay();
    Utility.trapFocus(this, this.forceFocus);
    Utility.forceFocus(this.forceFocus);
    // if(window.innerWidth < 1200 && opener.classList.contains('customMobileDrawer')){
      
    //   document.querySelectorAll('.shopify-section-group-header-group').forEach(each=>{each.style.zIndex = 'unset'})
    // }
    
  }
  closeDrawer() {
    this.isOpen = false;
    this.classList.remove('open');
    this.setAttribute('aria-hidden', 'true');
    this.openedBy?.setAttribute('aria-expanded', false);
    setTimeout(() => {
      this.classList.remove('collection-sorting');
    }, 500);
    document.body.classList.remove('bike-info-drawer-opened');
    this.section.classList.remove('info-drawer-opened');
    SiteOverlay.prototype.hideOverlay();
      Utility.removeTrapFocus(this.openedBy);
      this.openedBy = null;
    // if(window.innerWidth < 1200 ){
      
    //   document.querySelectorAll('.shopify-section-group-header-group').forEach(each=>{each.style.zIndex = '1150'})
    // }
    this.dispatchEvent(new Event("infodrawer:closed"));
}
   checkViewport() {
    if (window.innerWidth <= 992) {
      this.showOverlay = true;
    } else {
      this.showOverlay = false;
    }
  }
}

customElements.define('custom-drawer-bike-info', CustomDrawerBikeInfor);



const swiperSliders = document.querySelectorAll('swiper-container');
swiperSliders.forEach(swiperEle => {
  swiperEle.addEventListener('swiperslidechange', (event) => {
    const index = event.detail[0].activeIndex;
    const swipDirection = event.detail[0].swipeDirection;
    const prevSlide = swiperEle.querySelector(`swiper-slide[data-index="${swipDirection == 'prev' ? index+2 : index}"]`);
    const activeSlide = swiperEle.querySelector(`swiper-slide[data-index="${index+1}"]`);

    // Pause previous slide video if available
    if(prevSlide && prevSlide.querySelector('.custom-video-container.playing--video')){
      let customElement = prevSlide.querySelector('custom-video');
      let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
      if(videoEle && customElement.dataset.controls == 'true') {
        customElement._pauseVideo(videoEle);
      }
    }

    // Play active slide video if available
    if(prevSlide && activeSlide.querySelector('.custom-video-container')){
      let customElement = activeSlide.querySelector('custom-video');
      if(customElement.videoStatus == 'empty'){
        customElement.toggleView();
      }else{
        let videoEle = customElement.querySelector('video') || customElement.querySelector('iframe');
        if(videoEle) customElement._playVideo(videoEle);
      }
    }
  });
});
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll("[data-video-btn]").forEach(ele => {
  ele.addEventListener("click", event => {
    let videoEle = ele.closest("[data-video-parent]").querySelector("video");

    // Pause all other videos
    document.querySelectorAll("[data-video-parent]").forEach(element => {
      const otherVideo = element.querySelector("video");
      if (videoEle !== otherVideo) {
        otherVideo.pause();
        element.classList.remove("video-play");
      }
    });

    // Toggle play/pause for clicked video
    if (videoEle.paused) {
      videoEle.play();
      ele.closest("[data-video-parent]").classList.add("video-play");
    } else {
      videoEle.pause();
      ele.closest("[data-video-parent]").classList.remove("video-play");
    }
  });
});
});

if(!customElements.get('read-more')){
  class ReadMore extends HTMLElement {
  constructor() {
      super();
      this.actionBtn = this.querySelector('[data-read-more-btn]') ? this.querySelector('[data-read-more-btn]'):null;
      this.dataDetailContent = this.querySelector('[data-content-show]') ? this.querySelector('[data-content-show]'):null;
      this.readMoreTitle = this.querySelector('[data-read-more-title]') ? this.querySelector('[data-read-more-title]'): 'Read More';
      this.readLessTitle = this.querySelector('[data-read-less-title]') ? this.querySelector('[data-read-less-title]'): 'Read Less';
      this.expanded = false;
  }

  connectedCallback() {
    this.bindEvents();
  }
  bindEvents(){
    this.actionBtn?.addEventListener('click',this.toggleContent.bind(this))
  }
  toggleContent(e){
    e.preventDefault();
    if(!this.dataDetailContent) return;
    if(this.expanded){
      this.dataDetailContent?.classList.add('overflow-hidden');
      this.dataDetailContent.classList.remove('show-content');
      this.actionBtn.textContent = this.readMoreTitle; 
      this.expanded = false;
    }
    else{
      this.dataDetailContent?.classList.remove('overflow-hidden');
      this.dataDetailContent.classList.add('show-content');
      this.actionBtn.textContent = this.readLessTitle;
      this.expanded = true;
    }
    
  }
   
}
customElements.define('read-more', ReadMore);
}

// style frame drawer for collection


  class FrameDrawerOpen extends HTMLElement {
    constructor() {
        super();
        this.btn = this.querySelector('[data-frame-opener]') ? this.querySelector('[data-frame-opener]'):null;
        this.drawerTarget = this.getAttribute('data-drawer-target')? document.querySelector(`.${this.getAttribute('data-drawer-target')}`):null;

    }
    connectedCallback() {
      console.log("FrameDrawerOpen")
        this.btn.addEventListener('click',this.openDrawer.bind(this));

    }
    openDrawer(evt){
      evt.preventDefault()
      evt.stopImmediatePropagation();
      this.drawerTarget.openDrawer();
    }
    closeDrawer(){
      evt.preventDefault()
      evt.stopImmediatePropagation();
      this.drawerTarget.closeDrawer();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.openDrawer.bind(this));
      this.removeEventListener('touchend', this.openDrawer.bind(this));
    }
  }
  customElements.define('frame-drawer-open', FrameDrawerOpen);

  
  class FrameMobileDrawer extends HTMLElement {
    constructor() {
        super();
        this.btn = this.querySelector('[data-frame-opener]') ? this.querySelector('[data-frame-opener]'):null;
        this.frameMobileDrawer = document.querySelector('[data-frame-mobile-drawer]') ? document.querySelector('[data-frame-mobile-drawer]'):null;
        this.frameDrawerClose = document.querySelectorAll('[data-frame-drawer-close]');
        this.drawerFooter = document.querySelector('[data-filterfooter]')
    }
    connectedCallback() {
      this.btn.addEventListener('click',this.openDrawer.bind(this));
      this.frameDrawerClose.forEach((closeBtn)=>{
        closeBtn.addEventListener('click',this.closeDrawer.bind(this));
      })
    }
    openDrawer(evt){
      evt.preventDefault()
      evt.stopImmediatePropagation();
      this.frameMobileDrawer.classList.add('open');
      this.drawerFooter.classList.add('d-none');
    }
    closeDrawer(evt){
      evt.preventDefault()
      evt.stopImmediatePropagation();
      this.frameMobileDrawer.classList.remove('open');
      this.drawerFooter.classList.remove('d-none');
    }

  }
  customElements.define('frame--mobile-drawer-open', FrameMobileDrawer);

  class ProductStickyBar extends HTMLElement {
    constructor() {
      super();
      this.productContainer = document.querySelector('[data-product-container]') || null;
      this.addTocarBtn = this.querySelector('[data-sticky-addtocart]')? this.querySelector('[data-sticky-addtocart]'):null;
      this.tabList = Array.from(this.querySelectorAll('.sticky-nav-link'));
      this.globaleHeader = document.querySelector('.section-header');
    }
  
    connectedCallback() {
      if (this.productContainer) {
        this.observeProductContainer();
        this.section_list = Array.from(this.querySelectorAll('.sticky-nav-link')).map((navLink) =>navLink.getAttribute('href'));
        this.documentScrolling();
        this.scrollSectionObserver();
        this.tabList.forEach((tabItem)=>{tabItem.addEventListener('click',this.scrollToSection.bind(this))})
        if(this.addTocarBtn){
          this.addTocarBtn.addEventListener('click',this.triggerAddtoCart.bind(this));
        
        }
      }
 
    }
    scrollToSection(e){
        e.preventDefault()
        const sectionID = e.target.getAttribute('href');
        const section = document.getElementById(sectionID.replace('#', ''));
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }

    }
    scrollSectionObserver() {
      const sections = this.section_list
        .map((selector) => document.querySelector(selector))
        .filter(Boolean); // Skip nulls if a selector doesn't match
    
      const checkVisibleSection = () => {
        let visibleIndex = -1;
    
        for (let i = 0; i < sections.length; i++) {
          const rect = sections[i].getBoundingClientRect();
          if (rect.top <= 10 && rect.top >= 0) {
            visibleIndex = i;
            break;
          }
        }
        if (visibleIndex !== -1) {
          const activeMenulist = this.tabList.filter((tabItem)=> {
            if(tabItem.classList.contains('active')){
              return true;
            }
          });
          if(activeMenulist.length){
            activeMenulist[0].classList?.remove('active')
          }
          
          
          this.tabList[visibleIndex]?.classList.add('active');
        }
      };
    
      document.addEventListener("scroll", checkVisibleSection);
      checkVisibleSection(); // Optional: run on load
    }
    documentScrolling(){
      document.addEventListener('scroll',()=>{
        if(this.globaleHeader){
          const headerHeight = this.globaleHeader.clientHeight;
          if(this.globaleHeader.classList.contains('header-hidden')){
            this.style.top = 0;
          }
          else{
            this.style.top = `${headerHeight}px`;
          }
        }

      });
    }

    triggerAddtoCart(){
      this.addTocarBtn.classList.add('loading');
      
     
    }
    
    observeProductContainer() {
      const observer = new IntersectionObserver(
        ([entry]) => {
          
          if (!entry.isIntersecting) {
            this.classList.add('open');
            
          } else {
            this.classList.remove('open');
          }
        },
        {
          threshold: 0 
        }
      );
      observer.observe(this.productContainer);
    }
  }
  
  customElements.define('product-sticky-bar', ProductStickyBar);


  class customKlaviyo extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.successMsg = this.getAttribute('data-successmsg');
      this.subscribed = this.getAttribute('data-subscribed')
      this.responseInput = this.querySelector('[data-final-result]');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    
    /**
     * Klaviyo Form Submit event
     *
     * @param {evt} Event instance
     */
    onSubmitHandler(evt) {
      evt.preventDefault();
      const formURL = this.form.getAttribute('action');
      const submitButton = this.querySelector('[type="submit"]');
      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');
  
      // Validation Code
      const listID = this.form.querySelector('[name="g"]').value;
      const emailID = this.form.querySelector('[name="email"]').value;
      if(emailID.trim().length <= 0){
        this.responseInput.innerHTML = 'Empty Email';
        this.manageResponseText(this.responseInput);
        return;
      }else if(!Utility.validateEmail(emailID)) {
        this.responseInput.innerHTML = 'Invalid Email';
        this.manageResponseText(this.responseInput);
        return;
      }else if(listID == null || listID.length <= 0) {
        this.responseInput.innerHTML = 'Invalid List ID';
        this.manageResponseText(this.responseInput);
        return;
      }
  
      const data = new URLSearchParams();
      for (const pair of new FormData(this.form)) {
        data.append(pair[0], pair[1]);
      }
  
      fetch(formURL, {
        method: 'post',
        body: data,
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if(parsedState.success == false){
            const errortext = parsedState.errors[0];
            this.responseInput.innerHTML = errortext;
            // this.manageResponseText(this.responseInput);
          }else if(parsedState.success == true && parsedState.data.is_subscribed == true) {
            this.responseInput.innerHTML = this.subscribed;
            // this.manageResponseText(this.responseInput);
          }else{
            this.form.querySelector('[name="email"]').value = '';
            this.responseInput.innerHTML = this.successMsg;
            // this.manageResponseText(this.responseInput);
          }
          console.log(parsedState.data.is_subscribed, 'is_subscribed');
          if(parsedState.data.is_subscribed == true){
            this.responseInput.innerHTML = 'Already Subscribed !'
          }else{
  
            this.responseInput.innerHTML = 'Thanks For Subscribing !'
          }
          this.responseInput.style.display = 'block'
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }
  
    manageResponseText(element){
      // Utility.fadeEffect(element, 'fadeIn');
      // Utility.fadeEffect(element, 'fadeOut');
  
    }
  }
  customElements.define("custom-klaviyo", customKlaviyo);
  document.addEventListener("DOMContentLoaded", (event) => {
    const maxInterval = 10; 
    let attempts = 0;
    let shoppayLoaded = false;
    
    const shopPayfinder = setInterval(() => {
      const shopPayWrappers = document.querySelectorAll('[data-nametag="shop-portal-provider"]');
    
      if (shopPayWrappers.length) {
        shopPayWrappers.forEach((shopayElm) => {
          shopayElm.style.display = 'block';
        });
        shoppayLoaded = true;
        clearInterval(shopPayfinder); // Stop the interval if found
      }
    
      attempts++;
      if (attempts >= maxInterval) {
        if (!shoppayLoaded) {
          
        }
        clearInterval(shopPayfinder); // Stop the interval after 10s
      }
    }, 1000);
  });


  if (
    document.body.classList.contains('template-collection') || 
    document.body.classList.contains('template-search')
  ) {
    document.addEventListener('click', function (e) {
      // List of selectors to check for closest match
      const closestSelectors = ['#storefront-filter-grid', '#storefront-filter-grid'];
  
      // Find the first closest match
      const matchedClosest = closestSelectors.find((selector) => {
        return e.target.closest(selector);
      });
  
      // If click was NOT inside any of the closest elements
      if (!matchedClosest) {
        const allCollapsibles = document.querySelectorAll('#storefront-filter-grid [is="collapsiblePanel"].open');
        if(allCollapsibles.length == 0) return;
        allCollapsibles.forEach((collapsible) => {
          const button = collapsible.querySelector('button');
          if (button) button.click();
        });
      }
    });
  }
  document.addEventListener("DOMContentLoaded", (event) => {
    eventBus.subscribe(PUB_SUB_EVENTS.variantChange, (eventData) => {
      const { container, variant } = eventData.data;
      if (container && container.hasAttribute('data-product-card')) {
        if(variant.available){
          console.log(container.querySelector('[data-badge-sold-out]'));
          container.querySelector('[data-badge-sold-out]').classList.add('d-none');
        }
        else{
          container.querySelector('[data-badge-sold-out]').classList.remove('d-none');
        }
      }
    });
  });


  
  class globalCustomVideo extends HTMLElement {
    constructor() {
      super();
      this.videoType = this.getAttribute('data-video-type');
      this.loadVideo = this.querySelector('[data-load-button]');
      this.youtubeVideoUrl = this.getAttribute(['data-youtube-id']) ? this.getAttribute(['data-youtube-id']):null;
      this.videoURL = this.getAttribute(['data-video-url']) ? this.getAttribute(['data-video-url']):null;
      this.videoContainer = this.querySelector('[data-video-container]');
      this.localVideoplaypause = this.querySelector('[data-video-play]')
    }
    connectedCallback(){
      this.loadVideo.addEventListener('click',this.loadeVideo.bind(this));
      this.localVideoplaypause.addEventListener('click',this.localVideoPlayPause.bind(this));
    }
    localVideoPlayPause(){
      const videoElem = this.querySelector('video');

      // Pause all other videos
      const allVideoComponents = document.querySelectorAll('global-custom-video');
      allVideoComponents.forEach((videoComponent) => {
        if (videoComponent !== this) {
          const otherVideo = videoComponent.querySelector('video');
          const container = videoComponent.querySelector('[data-video-container]');
          if (otherVideo && !otherVideo.paused) {
            otherVideo.pause();
            container?.classList.remove('playing');
          }
        }
      });
      if (videoElem.paused) {
        videoElem.play();
        this.videoContainer.classList.add('playing');
      } else {
        videoElem.pause();
        this.videoContainer.classList.remove('playing');
      }
    }
    loadeVideo(){
      this.classList.add("global-video-loaded");
      if(this.videoType == 'youtube'){;
        this.buildVideo();
      }else{
        this.buildVideo();
        const videoElm = this.videoContainer.querySelector('video');
        if(videoElm) videoElm.play();
        this.videoContainer.classList.add('playing')

      }
    }
    buildVideo(){
      let video;
      if(this.videoType == 'youtube'){
        if(this.youtubeVideoUrl){
          const videoID = this.youtubeVideoUrl;
          video = document.createElement( "iframe" );
          video.setAttribute( "allowfullscreen", "" );
          video.setAttribute( "frameborder", "0" );
          video.setAttribute( "allow", "autoplay");
          video.setAttribute( "src", `https://www.youtube.com/embed/${videoID}?rel=0&showinfo=0&autoplay=0&muted=00&controls=$1&loop=0&enablejsapi=1&origin=${window.origin}` );
          this.videoContainer.appendChild(video);
        }
      }
      else{
        video = document.createElement('video');
        video.src = this.videoURL;
        video.controls = false;
        video.playsInline = true;
        video.muted = false;
        video.autoplay = true;
        video.loop = true;
        this.videoContainer.appendChild(video);
      }
      
    }
  }
  customElements.define("global-custom-video", globalCustomVideo);

  eventBus.subscribe(PUB_SUB_EVENTS.cartUpdate, (eventData) => {
    const cartForm = document.querySelector('cart-form');
    
    if(cartForm){
      console.log("cart updating..")
      cartForm.checkForExtendApp();
   
    }
  });
  
  
  // (function() {
  //   const originalFetch = window.fetch;
  
  //   window.fetch = async function(...args) {
  //     const [resource, config] = args;
  
  //     if (typeof resource === 'string' && resource.includes('/cart/add.js')) {
  //       console.log('Intercepted /cart/add.js fetch request:', args);
        
  //       // Call your custom function here
  //       yourCustomCallbackFunction(args);
  //     }
  
  //     return originalFetch.apply(this, args);
  //   };
  
  //   function yourCustomCallbackFunction(fetchArgs) {
  //     // Your logic here
  //     console.log("Callback triggered for /cart/add.js", fetchArgs);
  //     const cartForm = document.querySelector('cart-form');
  //         if(cartForm){
  //           console.log("observer call runnding");
  //           cartForm._updateCartStandAlone();
  //         }
  //   }
  // })();
// console.log("observer started")
// const observer = new PerformanceObserver((list) => {
//   for (const entry of list.getEntries()) {
//     const name = entry.name;
//     if (name.includes('add')) {
//       const cartForm = document.querySelector('cart-form');
//       if(cartForm){
//         console.log("observer call runnding");
//         cartForm._updateCartStandAlone();
//       }
//     }
//   }
// });
// observer.observe({ entryTypes: ['resource'] });